import { styled } from '@mui/material/styles';
import { Fab as MUIFab } from '@mui/material';

export const Fab = styled(MUIFab)`
  background-color: ${({ theme }) => theme.palette.neutral.var10};
`;
